import { Box, Stack } from "@mui/material";
import PageTitle from "../Displays/PageTitle";
import { useLocation } from "react-router-dom";
import PageSubTitle from "../Displays/PageSubTitle";
import { SELF_ONBOARDING_ROUTES } from "src/consts/routes";
import { SELF_ONBOARDING_ACCESS_PATHS } from "src/consts/paths";
import VerticalLinearProgress from "../ProgressBar/VerticalLinearProgressBar";

export const tariffCalculator = (pathname: string) => {
  switch (pathname) {
    case SELF_ONBOARDING_ROUTES.ACCESS_SUCCESS:
      return 55;
    case SELF_ONBOARDING_ROUTES.ACCESS_FAILED:
      return 55;
    default:
      return 0;
  }
};

const SelfOnboardingAccessProgressBar = () => {
  const { pathname } = useLocation();

  return (
    <Stack
      gap="13px"
      sx={{
        display: { xs: "none", sm: "flex" },
      }}
    >
      <PageTitle text={"Menü"} />
      {SELF_ONBOARDING_ACCESS_PATHS.includes(pathname) && (
        <Box
          sx={{
            gap: 3,
            height: 55,
            display: { xs: "flex", sm: "default" },
          }}
        >
          <VerticalLinearProgress
            variant="determinate"
            value={55 - tariffCalculator(pathname)}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <PageSubTitle text={"Hardware Zugriff"} />
            <PageSubTitle text={"Status"} />
          </Box>
        </Box>
      )}
    </Stack>
  );
};

export default SelfOnboardingAccessProgressBar;
